<template>
  <div id="app">
    <div
      class="screen"
      id="screen"
      :style="{ height: height, backgroundImage: img }"
    >
      <img
        class="chart-bg"
        :src="require('@/assets/images/circle.png')"
        alt=""
        id="chart-circle-bg"
      />
      <img
        class="chart-bg"
        :src="require('@/assets/images/circle_bg.png')"
        alt=""
        id="chart-circle-bg"
      />
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      height: "1080px",
      img: "",
    };
  },
  mounted() {
    // this.handleScreenAuto();
    // window.onresize = () => this.handleScreenAuto();
  },
  deleted() {
    window.onresize = null;
  },
  methods: {
    // 数据大屏自适应函数
    handleScreenAuto() {
      const designDraftWidth = 1920; //设计稿的宽度
      const designDraftHeight = 1080; //设计稿的高度
      this.height = "1080px";
      // 根据屏幕的变化适配的比例
      let scale =
        document.documentElement.clientWidth /
          document.documentElement.clientHeight <
        designDraftWidth / designDraftHeight
          ? document.documentElement.clientWidth / designDraftWidth
          : document.documentElement.clientHeight / designDraftHeight;
      // 缩放比例
      if (
        document.documentElement.clientWidth === 1920 &&
        document.documentElement.clientHeight === 1080
      ) {
        this.height = "100vh";
        scale = 1;
      }
      document.querySelector(
        "#screen"
      ).style.transform = `scale(${scale}) translate(-50%, -50%)`;
    },
  },
};
</script>

<style>
#app {
  height: 1080px;
  width: 100%;
  background-image: url("@/assets/images/bg.png");
}
.screen {
  display: inline-block;
  width: 1920px;
  height: 1080px;
  transform-origin: 0 0;
  position: absolute;
  /* left: 50%;
  top: 50%; */
  background-image: url("@/assets/images/bigBorder.png");
}
.chart-bg {
  position: absolute;
  top: 60px;
  width: 1058px;
  height: 780px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
